import { render, staticRenderFns } from "./ChargebeeUpsellMarketing.vue?vue&type=template&id=97a4b6fe&scoped=true&"
import script from "./ChargebeeUpsellMarketing.vue?vue&type=script&lang=js&"
export * from "./ChargebeeUpsellMarketing.vue?vue&type=script&lang=js&"
import style0 from "./ChargebeeUpsellMarketing.vue?vue&type=style&index=0&id=97a4b6fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a4b6fe",
  null
  
)

export default component.exports